export function PrivacyPage() {
  return (
    <div className="PrivacyPolicyView" style={{ padding: 20, fontFamily: "Verdana, Geneva, sans-serif", maxWidth: 700 }}>
      <h1>Privacy policy</h1>
      <p>
        GearGrams stores the gear lists you create, your email address and your name (if you give one) so that you
        can sign in and sync between devices. Lists you share by link are visible to anyone with the link. We do not
        sell or share your data with anyone. Email <a href="mailto:help@geargrams.com">help@geargrams.com</a> to have
        your account and data deleted, or use the delete button in Settings.
      </p>
    </div>
  );
}
